import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <p> &copy; 2024 Demo Blog. For example purposes only.</p>
        </footer>
    );
};

export default Footer;